import { array } from 'prop-types';
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { toast } from 'react-toastify';
import { ABOUT_US, CATEGORY, REASON } from '../config/apiEndPoint';
import { GET, POST, PUT } from 'config/api.config';

export const getReasonList = async (data = array()) => {
    try {
        let url = data?._Id ? `${REASON.GET_REASON_LIST}/${data?._Id}` : `${REASON.GET_REASON_LIST}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(response.message);
        // console.log(error);
    }
};

export const addReason = async (data = array()) => {
    try {
        const response = await POST(REASON.GET_REASON_LIST, data);
        return response;
    } catch (error) {
        toast.error(error.message);
    }
};

export const updateReason = async (id, data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${REASON.GET_REASON_LIST}/${id}`;
        const response = await PUT(url, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const getReasonDataById = async (data = array()) => {
    try {
        let url = data?.Id ? `${REASON.GET_REASON_LIST}/${data?.Id}` : `${REASON.GET_REASON_LIST}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(response.message);
        // console.log(error);
    }
};

export const fetchReasonTableAndFilterSchema = async (data = array()) => {
    try {
        let url = data?._Id ? `${REASON.GET_JOB_REASON_SCHEMA}/${data?._Id}` : `${REASON.GET_JOB_REASON_SCHEMA}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(response.message);
        // console.log(error);
    }
};

export const submitFilterData = async (data = array()) => {
    try {
        const response = await POST(REASON.SUBMIT_FILTER_DATA, data);
        return response;
    } catch (error) {
        toast.error(error.message);
    }
};

export const commonReasonData = async (data = array()) => {
    try {
        const response = await POST(REASON.COMMON_REASONS, {
            forTools: true
          });
        return response;
    } catch (error) {
        toast.error(error.message);
    }
};

export const commonReasonsForAll = async (data = array()) => {
    try {
        const response = await GET(REASON.COMMON_REASONS_FOR_ALL);
        return response;
    } catch (error) {
        toast.error(error.message);
    }
};



